import React from "react";
import { gql, useQuery } from "@apollo/client";
import Loader from "../../../genericComponents/Loader";
import LineChartCard from "./LineChartCard";

const HolidayChart = ({ id, level, meterType, start, end, height,width }) => {
    const GET_WEEKDAYCHART = `query holidayChart($id:UUID!,$level:Level!,$meterType:MeterType!,$start:DateTime!,$end:DateTime!){
        lineChartHoliday(chartInput:{id: $id,level: $level,meterType:$meterType,start:$start,end:$end}){
            isSuccess
            message
            value{
                name
                points{
                x
                y
                }
        }        
}     
    }
    `
    const { data, loading, error } = useQuery(gql(GET_WEEKDAYCHART),
        { variables: { id: id, level: level, meterType: meterType, start: start, end: end } }
    )
    if (loading||!data) {
        return <Loader height={height} text={"Loading data..."} />
    }    
    
    console.log({data});
    if (data.lineChartHoliday.isSuccess) {
        console.log(data.lineChartHoliday.value);
        const charts = data.lineChartHoliday.value.map(x => ({
            label: x.name,
            data: x.points
                .filter(y => y && y.x !== null && y.x !== undefined && y.y !== null && y.y !== undefined)
                .map((y, i) => ({ x: y.x, y: y.y, id: i }))
        }));
        
        // Filter out empty charts
        const validCharts = charts.filter(c => c.data.length > 0);
        
        if (validCharts.length === 0) {
            return <Loader height={height} text={"No data available"} />
        }
        
        console.log(validCharts);
        return <LineChartCard type="Holidays" meterType={meterType} width={width} height={height} charts={validCharts}/>
    } else {
        return "An error has occured:" + data.lineChartHoliday.message;
    }

};
export default HolidayChart;